import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import MapIcon from '@material-ui/icons/Map';
import { Button, Collapse } from '@material-ui/core';
import {
  StyledTextSubTitle,
  StyledTextTitle,
  StyledTextTitleZ,
} from '../Utils/TextStyles';
import './imageCard.css'

const useStyles = makeStyles({
  root: {
    fontFamily: 'Fecske',
    display: 'flex',
    maxWidth: 420,
    backgroundColor: '#e2e1e1',
    justifyContent: 'center',
  },
  details: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    maxWidth: 300,
  },
  media: {
    width: 350,
    height: 250,
    cursor: 'pointer'
  },
  title: {
    fontSize: '2rem',
  },
  desc: {
    fontSize: '1.1rem',
  },
});

export default function MediaControlCard({ place, checked, left }) {
  const classes = useStyles();
  const { name, imageUrl, description, btnText, mapIcon, url, description2 } = place
  return (
    <Collapse in={checked} {...(checked ? { timeout: 1000 } : {})} >
      <Card className={classes.root} elevation={0}>
        <CardContent>
          <div>
            <StyledTextTitle color={'#bb823f'} className={classes.title} style={{ textAlign: 'center' }}>{name}</StyledTextTitle>
            {place?.title ? <StyledTextTitleZ color={'#006d46'} style={{ textAlign: 'center' }}>{place.title}</StyledTextTitleZ> : null}
            <div key={`img${imageUrl}`} className={classes.media} style={{ border: place?.title ? 'solid 7px #bb823f' : '' }}
              onClick={() => window.open(url)}
            >
              <img alt={`img${imageUrl}`} className={classes.media} src={imageUrl} loading="lazy" />
            </div>
          </div>
          <CardContent className={classes.desc}>
            <StyledTextSubTitle color={'#00774f'} style={{ textAlign: 'center' }}>
              {description}
            </StyledTextSubTitle>
            {description2 ? <StyledTextSubTitle color={'#00774f'} style={{ textAlign: 'center' }}>
              {description2}
            </StyledTextSubTitle> : null}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button className='lblButton' onClick={() => window.open(url)}
                style={{
                  borderRadius: 20,
                  backgroundColor: '#006d46',
                  color: '#e2e1e1'
                }}>
                {mapIcon ? <MapIcon /> : null}
                {btnText}
              </Button>
            </div>
          </CardContent>
        </CardContent>
      </Card>
      {
        place?.url2 ? <Card className={classes.root} elevation={0}>
          <CardContent>
            <div>
              <CardMedia
                className={classes.media}
                image={place.imageUrl2}
                title={place.title}
                onClick={() => window.open(place.url2)}
              />
            </div>
            <CardContent className={classes.desc}>
              <StyledTextSubTitle color={'#00774f'} style={{ textAlign: 'center' }}>
                {place.description}
              </StyledTextSubTitle>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button className='lblButton' onClick={() => window.open(place.url2)}
                  style={{
                    borderRadius: 20,
                    backgroundColor: '#006d46',
                    color: '#e2e1e1'
                  }}>
                  {place.mapIcon ? <MapIcon /> : null}
                  {place.btnText}
                </Button>
              </div>
            </CardContent>
          </CardContent>
        </Card > : null
      }

    </Collapse >
  );
}
